export type TOption = {
  value: string;
  label: string;
};

export const LANGUAGE_OPTIONS: TOption[] = [
  {
    value: 'en',
    label: 'English',
  },
  {
    value: 'pt',
    label: 'Portuguese',
  },
  {
    value: 'es',
    label: 'Spanish',
  },
  {
    value: 'fr',
    label: 'French',
  },
];
